import { api } from './api';

export const getAreas = () => api.get('/api/areas');
